module.exports = __webpack_public_path__ + "static/media/verify-code_mobile.81162c6e.png";